
function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

function submitBannerForm() {
    var subscribe = jQuery('#banner-form .email').val();
    var button = jQuery('#banner-form .btn i');

    button.removeClass('fa-paper-plane-o');
    button.addClass('fa-cog').addClass('fa-spin');

    if (isEmail(subscribe)) {

        var form_element    = jQuery('#banner-form');
        var form_data       = jQuery(form_element).serialize() + "&action=submit_banner_form";

        jQuery.ajax({

            type: 'POST',

            url: theme_ajax.url,

            data: form_data,

            success: function(data, textStatus, XMLHttpRequest) {

                var update = jQuery.parseJSON(data);

                jQuery('#banner-form-container').html(update.message);

            },

            error: function(MLHttpRequest, textStatus, errorThrown) {
                console.log(MLHttpRequest);
                console.log(textStatus);
                console.log(errorThrown);
                alert('Error, please contact support.');

                button.removeClass('fa-cog').removeClass('fa-spin');
                button.addClass('fa-paper-plane-o');
            }

        });

    } else {
        alert('Please enter a valid email address.');
        button.removeClass('fa-cog').removeClass('fa-spin');
        button.addClass('fa-paper-plane-o');
    }
}



function submitFooterForm() {
    var subscribe = jQuery('#footer-form .email').val();
    var button = jQuery('#footer-form .btn i');

    button.removeClass('fa-paper-plane-o');
    button.addClass('fa-cog').addClass('fa-spin');

    if (isEmail(subscribe)) {

        var form_element    = jQuery('#footer-form');
        var form_data       = jQuery(form_element).serialize() + "&action=submit_footer_form";

        jQuery.ajax({

            type: 'POST',

            url: theme_ajax.url,

            data: form_data,

            success: function(data, textStatus, XMLHttpRequest) {

                var update = jQuery.parseJSON(data);

                jQuery('#footer-form-container').html(update.message);

            },

            error: function(MLHttpRequest, textStatus, errorThrown) {
                console.log(MLHttpRequest);
                console.log(textStatus);
                console.log(errorThrown);
                alert('Error, please contact support.');

                button.removeClass('fa-cog').removeClass('fa-spin');
                button.addClass('fa-paper-plane-o');
            }

        });

    } else {
        alert('Please enter a valid email address.');
        button.removeClass('fa-cog').removeClass('fa-spin');
        button.addClass('fa-paper-plane-o');
    }
}